import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { BlogArticleTemplate } from "@/components/BlogArticleTemplate";
import { articleBySlug } from "@/data/blog";
import { jsonLd, SITE_URL, absUrl } from "@/lib/seo";

const SLUG = "frisyr-sjalvfortroende";
const article = articleBySlug[SLUG]!;

export const Route = createFileRoute("/frisyr-sjalvfortroende")({
  head: () => ({
    meta: [
      { title: `${article.title} | Tailor's Barber` },
      { name: "description", content: article.metaDescription },
      { property: "og:type", content: "article" },
      { property: "og:title", content: article.title },
      { property: "og:description", content: article.metaDescription },
      { property: "og:image", content: absUrl(article.hero) },
      { property: "og:url", content: absUrl(`${SITE_URL}/frisyr-sjalvfortroende/`) },
    ],
    links: [{ rel: "canonical", href: absUrl(`${SITE_URL}/frisyr-sjalvfortroende/`) }],
    scripts: [
      jsonLd({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        description: article.metaDescription,
        image: absUrl(article.hero),
        datePublished: article.publishedAt,
        author: { "@type": "Organization", name: "Tailor's Barber" },
        publisher: {
          "@type": "Organization",
          name: "Tailor's Barber",
          url: SITE_URL,
        },
        url: `${SITE_URL}/frisyr-sjalvfortroende/`,
      }),
      jsonLd({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Hem", item: SITE_URL },
          { "@type": "ListItem", position: 2, name: "Blogg", item: `${SITE_URL}/blogg/` },
          { "@type": "ListItem", position: 3, name: article.title, item: `${SITE_URL}/frisyr-sjalvfortroende/` },
        ],
      }),
    ],
  }),
  component: () => (
    <SiteShell>
      <BlogArticleTemplate article={article} />
    </SiteShell>
  ),
});
